module.exports = __webpack_public_path__ + "img/video.c3d632ed.svg";